export const faqContent = {
  headingBefore: "We've answered all your ",
  headingHighlight: "questions",
  description:
    "Everything you need to know about our job fetching platform",
  cta: {
    question: "Still have questions?",
    buttonText: "Contact our support team",
  },
};

export const faqs = [
  {
    question: "Where do you fetch jobs from?",
    answer:
      "We fetch jobs from multiple trusted sources including Naukri, LinkedIn, Indeed, company career pages, and government portals. Our automated system collects job listings from these platforms and aggregates them in one convenient dashboard.",
  },
  {
    question: "How often is the data updated?",
    answer:
      "Our system automatically updates job data daily. You'll receive fresh job listings every day, ensuring you never miss out on new opportunities. You can also configure custom update frequencies based on your needs.",
  },
  {
    question: "Can I export data?",
    answer:
      "Yes! You can export job data in multiple formats including Excel and CSV. Enterprise plans also support direct integration with ATS systems for seamless data transfer.",
  },
  {
    question: "Is there a limit to how many jobs I can fetch?",
    answer:
      "Yes, the limit depends on your plan. Basic plan allows up to 300 job fetches per month, Professional plan allows up to 750, and Enterprise plan allows up to 2,000 job fetches per month. Contact us for custom limits if needed.",
  },
  {
    question: "Can multiple team members use the platform?",
    answer:
      "Yes! Basic plan supports 1 user, Professional plan supports up to 3 users, and Enterprise plan supports up to 20 users. All plans include team collaboration features like role assignment and shared job data.",
  },
  {
    question: "Do you support regional language job listings?",
    answer:
      "Yes, we support job listings in multiple regional languages. Our system can process and display jobs in various Indian languages, making it easier for you to find opportunities across different regions.",
  },
];
